import React from 'react';
import { UpgradePlanCard } from '../../components';
// import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
//import 'react-tabs/style/react-tabs.css';
// import Dropdown from 'react-dropdown';



const SettingCard = ({
  cnf,
  handleCnfChange,
  openIconModel,
  handleUpgradePlan
}) => {
  return (
    <div className="card card-editor card-header">
      <div className="card-editor-block p-0">
        <div className='card-plan-div'>
          <label className="card-editor-title">Setting</label>
          <UpgradePlanCard
            handleUpgradePlan={handleUpgradePlan}
          />
        </div>
        <div className="header-list">
          {cnf && cnf.m != undefined &&
            <div className="editor-input header-editor-ckeditor editor-header-caption">
              <label className="label-title">Time singular</label>
              <div className="time-multi">
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmmnt" type="text" value={cnf.m} onChange={(e) => handleCnfChange('m', e.target.value)} placeholder="Min"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmhurs" type="text" value={cnf.h} onChange={(e) => handleCnfChange('h', e.target.value)} placeholder="Hour"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmday" type="text" value={cnf.d} onChange={(e) => handleCnfChange('d', e.target.value)} placeholder="Day"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmmnth" type="text" value={cnf.mn} onChange={(e) => handleCnfChange('mn', e.target.value)} placeholder="Month"></input>
                </div>
                <div className="editor-input-timeago editor-input-fulltimeago">
                  <input className="editor-input-content editor-input-tmyear" type="text" value={cnf.yr} onChange={(e) => handleCnfChange('yr', e.target.value)} placeholder="Year"></input>
                </div>
              </div>
            </div>
          }
          {cnf && cnf.mplrl != undefined &&
            <div className="editor-input header-editor-ckeditor editor-header-caption">
              <label className="label-title">Time plural</label>
              <div className="time-multi">
                <div className="editor-input-timeago">
                  <input className="editor-input-content  editor-input-tmmnt" type="text" value={cnf.mplrl} onChange={(e) => handleCnfChange('mplrl', e.target.value)} placeholder="Minute"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmhurs" type="text" value={cnf.hplrl} onChange={(e) => handleCnfChange('hplrl', e.target.value)} placeholder="Hour"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmday" type="text" value={cnf.dplrl} onChange={(e) => handleCnfChange('dplrl', e.target.value)} placeholder="Day"></input>
                </div>
                <div className="editor-input-timeago">
                  <input className="editor-input-content editor-input-tmmnth" type="text" value={cnf.mnplrl} onChange={(e) => handleCnfChange('mnplrl', e.target.value)} placeholder="Month"></input>
                </div>
                <div className="editor-input-timeago editor-input-fulltimeago">
                  <input className="editor-input-content editor-input-tmyear" type="text" value={cnf.yrplrl} onChange={(e) => handleCnfChange('yrplrl', e.target.value)} placeholder="Year"></input>
                </div>
              </div>
            </div>
          }
          {cnf && cnf.flbkimgurl != undefined &&
            <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
              <label className="label-title">Verified by icon</label>
              <div className="browse-upload-part">
                <div className="browse-upload-show">
                  <img className="browse-upload-img" src={cnf.flbkimgurl} alt="fallback image" />
                </div>
                <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('flbkimgurl')}>
                  <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                    <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                  </svg>
                </label>
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  );
};

export default SettingCard;


// WEBPACK FOOTER //
// ./src/components/Widget/SettingCard.js